// extracted by mini-css-extract-plugin
module.exports = {"pagination":"PaginationButtons_pagination__xhtmI","paginationLink":"PaginationButtons_paginationLink__-j82S","current":"PaginationButtons_current__1zHGU"};